import { PRIVATE_ADMIN, PRIVATE_USER } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_USER_LIST_USERS = PRIVATE_USER + '/list-users';
export const PRIVATE_USER_FORM_USER = PRIVATE_USER + '/form-user';
export const PRIVATE_ADMIN_LIST_USERS = PRIVATE_ADMIN + '/list-users';
export const PRIVATE_ADMIN_FORM_USER = PRIVATE_ADMIN + '/form-user';
export const PROPOSAL_PROJECT = PRIVATE_USER + '/proposal-project';
export const APPLICATIONS_USER = PRIVATE_USER + '/applications';
export const IMPROVEMENT_CHANNEL = PRIVATE_USER + '/improvement-channel';
export const DELEGATION_SERVICE = PRIVATE_USER + '/delegation-service';
export const IMPROVEMENT_PROPOSAL = PRIVATE_USER + '/improvement-proposal';
export const PORTAL_USER = PRIVATE_USER + '/portal';
export const PRIVATE_USER_VALIDATION_ORGCHARTS = PRIVATE_USER + '/organigramas-validaciones';

